export default [
  {
    path: 'historyPerformance',
    title: '历史业绩',
    name: 'historyPerformance',
    component: () =>
      import(
        /* webpackChunkName: "historyPerformance" */ '@/pages/historyData/historyPerformance.vue'
      ),
  },
  {
    path: 'originalPlatformData',
    title: '原平台数据',
    name: 'originalPlatformData',
    component: () =>
      import(
        /* webpackChunkName: "originalPlatformData" */ '@/pages/historyData/originalPlatformData.vue'
      ),
  },
];
